import Vue from 'vue';
import * as C from '../constants';

export default {
  [C.SKI_DOMAIN_SET](state, payload) {
    Vue.set(state, 'selectedDomainId', payload);
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/ski/mutations.js